//import React from "react"
import styled from "styled-components"
import { slideFromBottom } from "./animations"

/** Header is the outer / top-level component for a header at the top of a typical page.
 * A header is logically split in up to three areas:
 * - Overview: Identifies the subject of the page, and contextualises it with e.g. breadcrumbs navigation.
 * - Facts: Key/value pairs for high-level status and configuration information.
 * - Actions: Controls to change high-level status and settings.
 *
 * Note: It's bad UX to duplicate the same context in both facts and actions.
 * If a high-level fact is changeable by the user, this should be represented
 * by a clear control in Actions only. Facts are generally for read-only values, or
 * ones which are changed elsewhere in the system.
 */
export const Header = styled.div`
  border-radius: ${(props) => props.theme.corners};
  display: flex;
  flex-direction: row;
  padding 0.5rem;
  background-color: ${(props) => props.theme.colours.nav};
  align: stretch;
  margin-bottom: 1rem;
  overflow: hidden;
`

// TODO: High-level utilities within header, such as loading, failed, etc? (with it taking
// care of the rendering)

const Module = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`

/** Overview is the left-most, or sometimes only, module of a header, typically containing
 * a heading, breadcrumbs, and perhaps a summary / paragraph. */
export const Overview = styled(Module)`
  flex: auto;
  align-items: stretch;
  padding 0.5rem;
  border-right: 2px solid rgba(0, 0, 0, 0.1);
  h1,
  h2,
  h3,
  h4{
    margin: 0;
    padding: 0 0 0.25rem 0;
  }
  p {
    margin: 0;
    padding: 1rem 0;
    color: ${(props) => props.theme.colours.text.secondary};
    &:last-child {
      padding-bottom: 0;
    }
  }
`

export const Facts = styled(Module)`
  flex: auto;
  display: grid;
  padding 0.5rem 1rem;
  grid-template-columns: 1fr 2fr;
  border-left: 2px solid rgba(190, 190, 190, 0.1);
  border-right: 2px solid rgba(0, 0, 0, 0.1);
  > dt {
    font-weight: bold;
    font-size: 0.8rem;
  }
  p, h1, h2, h3, h4, h5 {
    margin: 0;
    padding: 0 0 0.75rem 0;
    grid-column: span 2;
  }
`

export const Actions = styled(Module)`
  //border-radius: ${(props) => props.theme.corners};
  padding 0.5rem 1rem;
  //background-color: rgba(180, 180, 180, 0.1);
  //box-shadow: 4px 4px 15px rgba(0, 0, 0, 0.2);
  flex: none;
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.75rem;
  border-left: 2px solid rgba(190, 190, 190, 0.1);
`
export const Action = styled(Module)`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  animation: 0.3s ${slideFromBottom} ease-out;
  min-width: 12rem;
  > a {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
  }
  > label {
    display: flex;
    > span {
      flex: auto;
    }
  }
`
export const ActionLink = styled.a`
  display: flex;
  flex-direction: row !important;
  svg {
    flex: none;
    &:last-child {
      margin-left: 1rem;
    }
    &:first-child {
      margin-right: 1rem;
    }
  }
  span {
    flex: auto;
  }
`
